(function(){
  function num(el){
    if(!el)return 0;
    var v=(el.textContent||'').replace(/[^\d.]/g,'');
    return parseFloat(v)||0;
  }

  function one(p){
    if(p.querySelector('.vt-off'))return;
    var st=p.querySelector('s');
    if(!st)return;

    var txt=(p.innerText||'').replace(/\s+/g,' ');
    var raw=txt.match(/[\d,]+(?:\.\d+)?/g)||[];
    var nums=[];
    for(var i=0;i<raw.length;i++){
      var n=parseFloat(raw[i].replace(/,/g,''));
      if(n>0)nums.push(n);
    }
    if(nums.length<2)return;

    var hi=Math.max.apply(null,nums);
    var lo=Math.min.apply(null,nums);
    if(hi<=lo)return;

    var pct=Math.round((1-lo/hi)*100);
    if(pct<1||pct>99)return;

    var tag=document.createElement('span');
    tag.className='vt-off';
    tag.textContent=pct+'% OFF';
    var box=p.querySelector('.price__sale')||st.parentElement||p;
    box.appendChild(tag);
  }
  
  function tagBadges(){
    var b=document.querySelectorAll('.card__badge .badge');
    for(var i=0;i<b.length;i++){
      try{
        if(b[i].classList.contains('vt-sale')||b[i].classList.contains('vt-soldout'))continue;
        var t=(b[i].textContent||'').trim().toLowerCase();
        b[i].classList.add(t.indexOf('sold')>-1?'vt-soldout':'vt-sale');
      }catch(e){}
    }
  }

  function run(){
    var list=document.querySelectorAll('.price');
    for(var i=0;i<list.length;i++){
      try{one(list[i]);}catch(e){}
    }
    try{tagBadges();}catch(e){}
  }

  var timer=null;
  function schedule(){
    if(timer)return;
    timer=setTimeout(function(){timer=null;run();},300);
  }

  function boot(){
    run();
    var passes=0;
    var iv=setInterval(function(){
      run();
      if(++passes>9)clearInterval(iv);
    },700);
    window.addEventListener('load',run);
    new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  }

  document.readyState==='loading'
    ?document.addEventListener('DOMContentLoaded',boot)
    :boot();
})();
